import React from 'react'

import { Text } from '../presentation/Text'
import FlexGrid, { FlexColumn } from '../structure/FlexGrid'
import Link from '../actions/Link'
import ListItemWrapper from './ListItemWrapper'
import Radio from '../shapes/Radio'
import Separator from '../helpers/Separator'

const RadioListItem = ({ selected, onSelect, label }) => {
  return (
    <Link block onClick={onSelect}>
      <ListItemWrapper>
        <FlexGrid>
          <Radio active={selected} />
          <Separator vertical weight={3} />
          <FlexColumn flex={1}>
            <Text>{label}</Text>
          </FlexColumn>
        </FlexGrid>
      </ListItemWrapper>
    </Link>
  )
}

export default RadioListItem
